/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import { isDesktop } from '../../../utils/mobileHelpers';
import Paper from '../../Paper';
import ActionButton from '../../common/ActionButton';
import Icon from '../../Icon';

import styles from './index.styl';
import { COLORS } from '../../../constants/styles';
import { COMMUNUNNITY_NEW_POST } from '../../../constants/strings';

const getLocation = href => {
  const link = document.createElement('a');
  link.href = href;

  return link.hostname;
};

const TITLE_LIMIT = isDesktop() ? 100 : 60;
const DESCRIPTION_LIMIT = isDesktop() ? 130 : 80;

const getEllipsisText = (text, limit) =>
  text.length < limit ? text : `${text.slice(0, limit)}...`;

const getValidVideoUrl = src => src.replace('autoplay=1', 'autoplay=0');

const UrlPreview = ({
  readonly,
  className,
  description,
  title,
  preview,
  video,
  url,
  onCancel,
  intl,
}) => (
  <Paper zDepth={8} styleName="url-preview" className={className}>
    <div className="df">
      <Choose>
        <When condition={video && video !== 'null'}>
          <iframe
            styleName="videoPlayer"
            src={getValidVideoUrl(video)}
            frameBorder="0"
            gesture="media"
            allow="encrypted-media"
            allowFullScreen
          />
          <If condition={!readonly}>
            <div styleName="actionButtonWrapper">
              <ActionButton
                onClick={onCancel}
                style={{
                  ...(!isDesktop() && {
                    width: '30px',
                    height: '30px',
                    borderRadius: '4px',
                  }),
                }}
              >
                <Icon name="close" size={20} style={{ fill: COLORS.white }} />
              </ActionButton>
            </div>
          </If>
        </When>
        <Otherwise>
          <div styleName="preview-image">
            <Choose>
              <When condition={preview && preview !== 'null'}>
                <img src={preview} />
              </When>
              <Otherwise>
                <div styleName="no-preview">
                  {intl.formatMessage(COMMUNUNNITY_NEW_POST.noPreview)}
                </div>
              </Otherwise>
            </Choose>
          </div>
          <div styleName="description-pane" className="pl3">
            <h3 className="flex items-center justify-between pr1">
              <div style={{ flexGrow: 1 }}>
                <If condition={title && title !== 'null'}>
                  {getEllipsisText(title, TITLE_LIMIT)}
                </If>
                &nbsp;
              </div>
              <If condition={!readonly}>
                <ActionButton onClick={onCancel}>
                  <Icon name="close" size={24} style={{ fill: COLORS.white }} />
                </ActionButton>
              </If>
            </h3>
            <div>
              <If condition={description && description !== 'null'}>
                {getEllipsisText(description, DESCRIPTION_LIMIT)}
              </If>
              &nbsp;
            </div>
            <p styleName="link">{getLocation(url)}</p>
          </div>
        </Otherwise>
      </Choose>
    </div>
  </Paper>
);

UrlPreview.propTypes = {
  description: PropTypes.string,
  preview: PropTypes.string,
  video: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default injectIntl(CSSModules(UrlPreview, styles));



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/UrlPreview.jsx